export default __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/apple_podcasts-2e5fe26819060d7d21ff480631e7000a.svg";